















import {Component, Prop, Vue} from 'vue-property-decorator';
import {InputVariableViewModel} from '@/features/bots/models/designer';
import EmojiIcon from 'vue-material-design-icons/EmoticonHappyOutline.vue';
import { mixin as clickaway } from 'vue-clickaway';
import {Getter} from 'vuex-class';
import EmojiPicker from '@/features/bots/components/designer/TextEditor/EmojiPicker.vue';
import VariablePicker from '@/features/bots/components/designer/VariablePicker/VariablePicker.vue';
import CodeIcon from 'vue-material-design-icons/CodeBrackets.vue';

@Component({
	components: {
		EmojiIcon,
		EmojiPicker,
		VariablePicker,
		CodeIcon
	},
	mixins: [clickaway],
})
export default class ActionBar extends Vue {
	@Prop({default: true}) public showVariablePicker: boolean;
	@Getter public flowVariables!: InputVariableViewModel[];

	public isVariablePickerOpen: boolean = false;
	public isEmojiPickerOpen: boolean = false;

	public addVariableToText(variable: InputVariableViewModel) {
		this.isVariablePickerOpen = false;
		this.$emit('addVariable', variable);
	}

	public insertEmoji(emoji: any) {
		this.closeEmojiPicker();
		this.$emit('addEmoji', emoji.native);
	}

	public closeEmojiPicker() {
		this.isEmojiPickerOpen = false;
	}

	public toggleEmojiPicker() {
		this.isEmojiPickerOpen = !this.isEmojiPickerOpen;
		if (this.isEmojiPickerOpen) {
			this.isVariablePickerOpen = false;
		}
	}

	public closeVariablePicker() {
		this.isVariablePickerOpen = false;
	}

	public getNameAttributes(): InputVariableViewModel[] {
		const firstName = {
			key: 'givenName',
			id: 'givenName',
			scope: 'appUser',
			dataType: 'text',
			name: 'First Name',
		} as InputVariableViewModel;

		const secondName = {
			key: 'surname',
			id: 'surname',
			scope: 'appUser',
			dataType: 'text',
			name: 'Last Name',
		} as InputVariableViewModel;

		return [firstName, secondName];
	}
}
